/* eslint-disable react/jsx-filename-extension */
/* eslint-disable import/prefer-default-export */
import React from 'react';
import { shouldUseNativeAuth } from '@app/helpers/platform';
import { Button } from '@chakra-primitives/button';
import { useSafeAuth } from '../../hooks/use-safe-auth';
import { getNativeAuthBridge } from '../../utils/native-auth-bridge';

// Display button with "Home", used for oauth error screen and splash screen
export const Logout = () => {
  const { oktaAuth } = useSafeAuth();

  const logout = async () => {
    if (shouldUseNativeAuth()) {
      // For native auth: use the bridge to sign out
      try {
        const nativeBridge = getNativeAuthBridge();
        await nativeBridge.signOut();
      } catch (error) {
        console.error('Native auth logout failed:', error);
        // Fallback to web auth logout
        oktaAuth.signOut('/');
      }
    } else {
      // For web auth: use standard oktaAuth client
      oktaAuth.signOut('/');
    }
  };

  return (
    <Button className="home-button" onClick={logout}>
      Back to Login
    </Button>
  );
};
